import { zodResolver } from "@hookform/resolvers/zod";
import type { SubmitHandler } from "react-hook-form";
import { useForm } from "react-hook-form";

import type { TwoFactorAuthFormValuesType } from "@/types";
import { twoFactorAuthFormSchema } from "@/types";
import { Button, FormField } from "@/ui";
import { Input } from "@/ui/common";

interface RecoveryCodeChallengeProps {
  handleShowRecoveryCode: () => void;
  hasTwoFaError: boolean;
  onSubmit: SubmitHandler<{
    code: string;
  }>;
  isLoading: boolean;
}
export const RecoveryCodeChallenge = ({
  handleShowRecoveryCode,
  onSubmit,
  hasTwoFaError,
  isLoading,
}: RecoveryCodeChallengeProps) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<TwoFactorAuthFormValuesType>({
    resolver: zodResolver(twoFactorAuthFormSchema),
  });

  return (
    <>
      <div className="flex flex-col gap-y-2 text-center text-primary-950">
        <h1 className="text-2xl font-bold">Enter recovery code</h1>

        <p>You can use any code from your Recovery codes file.</p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-10">
        <FormField error={errors.code?.message}>
          <Input
            placeholder="Enter recovery code"
            {...register("code")}
            error={hasTwoFaError ? "Invalid code" : errors.code?.message}
            disabled={isLoading}
          />
          {hasTwoFaError && (
            <p className="text-center text-error-700">
              Invalid code, please try again.
            </p>
          )}
        </FormField>

        <div className="flex flex-col gap-y-6">
          <button
            type="button"
            onClick={handleShowRecoveryCode}
            className="self-center border-b text-sm font-bold text-primary-950"
          >
            Use Authenticator app
          </button>
          <Button
            className="w-full font-semibold"
            type="submit"
            isLoading={isLoading}
            disabled={isLoading}
          >
            Verify and continue
          </Button>
        </div>
      </form>
    </>
  );
};
